import { apiCall } from "@/shared/services/apiCall";
import { errorToast, successToast, helper } from "@/shared/services/helper";
import dateTime from "@/shared/services/dateTime";
import store  from "@/store/index";

const getWalletHistory = async (formDates) => {
    let responseObj = {
        walletHistoryData: null,
        error: false
    }
    try{
        let query ={
            from: formDates.fromDate,
            to: dateTime.getDateAddedByDays(1,formDates.toDate)
        }
        let response = await apiCall('get', 'WALLET_HISTORY', null, 'wallet', query)
        if (!response?.data?.success) {
            errorToast(response.data.message);
            responseObj.error = true
        }else{
            responseObj.walletHistoryData = response.data.data
        } 
        return responseObj;
    }catch(error){
        console.log('wallet',error)
        errorToast(error);
        return { error : error }
    }
};
const getTransactionStatus = (status) => {
    switch (status) {
        case 'pending':
            return { label: 'Pending', class: 'status-pending' };
        case 'approve_completed':
            return { label: 'Approved', class: 'status-approved' };
        case 'approve_in_process':
            return { label: 'Approve In Process', class: 'status-approved' };
        case 'reject_completed':
            return { label: 'Rejected', class: 'status-reject' };
        case 'reject_in_process':
            return { label: 'Reject In Process', class: 'status-reject' };
        case 'hold':
            return { label: 'In Process', class: 'status-pending' };
        case 'expired':
            return { label: 'Expired', class: 'status-reject' };
        case 'cancelled':
            return { label: 'Cancelled', class: 'status-reject' };
    }
};
const cancelRequest = async(id) => {
    let responseObj = {
        error: false
    }
    try{
        let query ={
            transactionId: id
        }
        let response = await apiCall('patch', 'CANCEL_REQUEST', {}, 'wallet', query)
        if (!response?.data?.success) {
            errorToast(response.data.message);
            responseObj.error = true
        }else{
            successToast(response.data.message)
        } 
        return responseObj;
    }catch(error){
        errorToast(error);
        responseObj.error = true
        return responseObj;
    }
};
export {
    getWalletHistory,
    getTransactionStatus,
    cancelRequest
}